import styled, { css } from 'styled-components';

export const Message = styled.p`
  margin: 0;
  line-height: 1.5;
`;

export const UsageList = styled.ul`
  display: flex;
  flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
  list-style: none;
  padding: 0;

  ${({ theme: { spacing } }) => css`
    margin: ${spacing.level3} 0 0;
    gap: ${spacing.level2};
  `}
`;

export const UsageRow = styled.li`
  display: flex;
  align-items: baseline;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing.level2};
`;

export const UsageKind = styled.span`
  flex-shrink: 0;

  ${({ theme: { colors, font } }) => css`
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const UsageName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.onSurface};
`;
